import * as React from "react";
const SvgFiBrandsVidevo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-videvo_svg__a)">
      <path
        fill="#151A2D"
        d="M2.06.23C3.15-.3 4.58.11 5.1 1.25 7.42 6.24 9.69 11.28 12 16.27c2.31-4.93 4.54-9.9 6.81-14.84.3-.68.78-1.22 1.54-1.37 1.21-.27 2.35.37 2.74 1.53.34 1.06-.28 1.96-.68 2.89-2.76 6-5.5 12.01-8.25 18.01-.26.54-.52 1.04-1.09 1.3-.6.25-1.36.26-1.98.06-.73-.28-.97-.91-1.29-1.56C7.19 16.65 4.58 11.01 2 5.36c-.37-.84-.86-1.68-1.11-2.57C.64 1.78 1.12.69 2.06.23"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-videvo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsVidevo;
